// extracted by mini-css-extract-plugin
export var checkboxInputRow = "z_sY";
export var checkboxInputColumn = "z_sZ";
export var inputOptionRow = "z_qk";
export var inputOptionColumn = "z_ql";